import { usePasteAndDropImageHandler } from "../../../Hooks/Features/HelpDesk/usePasteAndDropImageHandler";

const PasteAndDropImageHandler = ({ disabled, selectedImages, setSelectedImages }) => {
  const { pasteAreaRef, isDragOver } = usePasteAndDropImageHandler({ disabled, selectedImages, setSelectedImages })


  return (
    <div className="w50" style={{ height: "10px" }}>
      <div className="paste-field ">
        <div
          ref={pasteAreaRef}
          contentEditable={!disabled}
          role="textbox"
          tabIndex={0}
          aria-label="Paste or drag & drop images here"
          placeholder="Paste or drag & drop images here"
          style={{
            border: "2px dashed #ccc",
            borderColor: isDragOver ? "#3f51b5" : "#ccc",
            backgroundColor: isDragOver ? "#e3f2fd" : "transparent",
            height: "35px",
            outline: "none",
            cursor: disabled ? "not-allowed" : "text",
            padding: "4px",
            overflowY: "auto",
            userSelect: "text",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            transition: "background-color 0.3s, border-color 0.3s",
            borderRadius: "6px",
          }}
          suppressContentEditableWarning={true}
        >
          {isDragOver && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "1rem",
                color: "#3f51b5",
                pointerEvents: "none",
                userSelect: "none",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                borderRadius: "6px",
              }}
            >
              Drop here
            </div>
          )}
          {!isDragOver && <span>Paste or drag & drop here</span>}
        </div>
      </div>
    </div>
  );
};

export default PasteAndDropImageHandler;
